import { JamSchool } from './JamSchool';

export type { TypeJamSchoolProps } from './types';
export default JamSchool;
